"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateByWords = exports.truncateByLength = void 0;
const determineTags = (text, droppedText, finalText) => {
    let result = finalText;
    //if a closing tag and the end of it isn't included then set the string to the whole tag
    const selfClosingTag = text.match(/<(.*?)(["\d\w\s])\/>/gi);
    if (selfClosingTag && result.indexOf('/>') === -1) {
        result = text
            .split('')
            .splice(0, text.indexOf('/>') + 2)
            .join('');
    }
    const openTags = droppedText.match(/(?!<\/)<([a-zA-Z0-9-"=\s/:.]*)>/g);
    const closingTags = droppedText.match(/<\/([a-zA-Z0-9-]*)>/g);
    if (closingTags && closingTags.length && (!openTags || openTags.length !== closingTags.length)) {
        const tagsFound = {};
        closingTags.forEach((tag, i) => {
            if (result.indexOf(tag) > -1) {
                tagsFound[i] = tag;
            }
            else {
                tagsFound[i] = false;
            }
        });
        closingTags.forEach((tag, i) => {
            if (!tagsFound[i]) {
                result += tag;
            }
        });
    }
    result += '...';
    // Hack if the above matching fails, just return the full string.
    // https://stackoverflow.com/questions/1732348/regex-match-open-tags-except-xhtml-self-contained-tags#answer-1732454
    const openers = /</gi;
    const closers = />/gi;
    const openersMatch = result.match(openers);
    if (openersMatch && openersMatch.length !== result.match(closers).length) {
        return text;
    }
    return result;
};
const truncateByWords = (text, maxWords) => {
    if (!text)
        return '';
    const max = maxWords || 60;
    const splitText = text.split(' ');
    let finalText = text;
    if (splitText.length > max) {
        finalText = text
            .split(' ')
            .splice(0, max)
            .join(' ');
        const droppedText = text
            .split(' ')
            .splice(max, text.length)
            .join(' ');
        finalText = determineTags(text, droppedText, finalText);
    }
    return finalText;
};
exports.truncateByWords = truncateByWords;
const truncateByLength = (text, limit) => {
    if (!text)
        return '';
    const max = limit || 300;
    let finalText = text;
    if (text.length > max) {
        finalText = text
            .split('')
            .splice(0, max)
            .join('');
        const droppedText = text
            .split('')
            .splice(max, text.length)
            .join('');
        finalText = determineTags(text, droppedText, finalText);
    }
    return finalText;
};
exports.truncateByLength = truncateByLength;
//# sourceMappingURL=string.js.map